export const QUERY_STALE_TIME = {
    detail: 1000 * 30,
    permission: 5 * 60 * 1000,
    sseStatus: Infinity,
};

export const remoteControlKeys = {
    all: ['bi-directional'] as const,
    detail: (equipmentId: string) => [...remoteControlKeys.all, equipmentId] as const,
    permission: (assetId: string) => ['remote-control', 'permission', assetId] as const,
    sseStatus: (serialNumber: string) => ['remote-control', 'sse-status', serialNumber] as const,
};
